import MiniBox from "../../componets/MiniBox";
import benefitsData from "../../data/uiAndUxDesignBenefits.json";

export default function Section5() {
  return (
    <div className="Section5 p-[2%] my-[40px] md:mb-[4%] md:mt-[5%] text-center bg-[url('/public/assets/magento-rectangle.png')]">
      <h2 className="text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-white my-[0.67em]">
        Why Choose Mean3 for UI/UX Design
      </h2>

      <MiniBox
        data={benefitsData}
        containerStyle="w-[90%] gap-y-[19px] md:gap-y-[30px] gap-x-[1%]"
        boxStyle="w-full xs:w-[40%] md:w-[26%] lg:w-[16%] p-[15px_20px]"
        headingStyle="text-[#2F2F2F] pb-[4%]"
        textStyle="text-[#373737]"
      />
    </div>
  );
}
